import { ChangeEvent } from 'react';
import { TextField, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

import AuthInputsContainer from 'components/AuthInputsContainer';
import AuthLink from 'components/AuthLink';
import AuthPage from 'components/AuthPage';
import FormCard from 'components/FormCard';
import Button from 'components/Button';
import { ROUTES } from 'navigation/constants';

interface ILogin {
  email: string;
  error: string;
  success: string;
  isLoading: boolean;
  onEmailChange: (value: string) => void;
  onSubmit: React.FormEventHandler;
}

const StyledInput = styled(TextField)({
  marginBottom: 12,
});

const ErrorText = styled('div')(props => ({
  fontSize: 14,
  fontWeight: 400,
  color: props.theme.palette.error.light,
}));

const SuccessText = styled('div')(props => ({
  fontSize: 14,
  fontWeight: 400,
  color: props.theme.palette.success.main,
}));

const ForgotPassword = ({ onEmailChange, onSubmit, email, error, success, isLoading }: ILogin) => {
  const { t } = useTranslation();
  
  const handleEmailChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onEmailChange(e.target.value);
  };

  return (
    <AuthPage>
      <FormCard onSubmit={onSubmit}>
        <AuthInputsContainer>
          <StyledInput
            onChange={handleEmailChange}
            value={email}
            placeholder={t('auth.email')}
            type="email"
          />
          {!!error && <ErrorText>{error}</ErrorText>}
          {!!success && <SuccessText>{success}</SuccessText>}
          <Button text={t('auth.sendEmail')} isLoading={isLoading} />
          <AuthLink linkText={t('auth.signIn')} link={ROUTES.LOGIN.path} />
        </AuthInputsContainer>
      </FormCard>
    </AuthPage>
  );
};

export default ForgotPassword;
